import { useQuery } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import { PencilIcon } from "lucide-react";
import { useState } from "react";
import { Button as AriaButton } from "react-aria-components";

import { useViewerHasPermission } from "@/auth/shared";
import { tagStyles } from "@/components/base/tag-group";
import { ToggleRosterPublishedForm } from "@/components/tournaments/controls/toggle-roster-published";
import { useTRPC } from "@/integrations/trpc/react";

export function RosterPublishedTag() {
  const canUpdate = useViewerHasPermission({ tournaments: ["update"] });

  const { tournamentId: tournamentIdStr, divisionId: divisionIdStr } =
    useParams({
      from: "/tournaments/$tournamentId/$divisionId/{-$tab}",
    });

  const tournamentId = Number.parseInt(tournamentIdStr, 10);
  const divisionId = Number.parseInt(divisionIdStr, 10);

  const trpc = useTRPC();

  const { data: division } = useQuery({
    ...trpc.tournaments.get.queryOptions({ id: tournamentId }),
    select: (data) =>
      data?.tournamentDivisions.find(({ id }) => id === divisionId),
  });

  const [isOpen, setIsOpen] = useState(false);

  if (!canUpdate || !division) {
    return null;
  }

  return (
    <>
      <AriaButton
        className={tagStyles({
          color: division.rosterPublished ? "green" : "yellow",
          className: "cursor-pointer",
        })}
        onPress={() => setIsOpen(true)}
      >
        {division.rosterPublished ? "Published" : "Unpublished"}
        <PencilIcon className="size-3" />
      </AriaButton>
      <ToggleRosterPublishedForm
        tournamentId={tournamentId}
        division={division}
        isOpen={isOpen}
        onOpenChange={setIsOpen}
      />
    </>
  );
}
